(function () {
  function enableDragScroll(container) {
    if (!container) return;
    let isDown = false, startX = 0, scrollLeft = 0;

    container.addEventListener('mousedown', (e) => {
      isDown = true;
      container.classList.add('is-dragging');
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    });
    ['mouseleave', 'mouseup'].forEach(evt =>
      container.addEventListener(evt, () => {
        isDown = false;
        container.classList.remove('is-dragging');
      })
    );
    container.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 1; // multiplier = speed
      container.scrollLeft = scrollLeft - walk;
    });

    // touch support
    let tStartX = 0, tScrollLeft = 0;
    container.addEventListener('touchstart', (e) => {
      const t = e.touches[0];
      tStartX = t.pageX - container.offsetLeft;
      tScrollLeft = container.scrollLeft;
    }, { passive: true });

    container.addEventListener('touchmove', (e) => {
      const t = e.touches[0];
      const x = t.pageX - container.offsetLeft;
      const walk = (x - tStartX) * 1;
      container.scrollLeft = tScrollLeft - walk;
    }, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // আপনার স্লাইডারের র‍্যাপার ক্লাস/আইডি এখানে দিন
    document.querySelectorAll('.dimension-slider, .js-drag-scroll').forEach(enableDragScroll);
  });

  // Theme editor live preview (section re-render হলে)
  document.addEventListener('shopify:section:load', function (evt) {
    evt.target.querySelectorAll('.dimension-slider, .js-drag-scroll').forEach(enableDragScroll);
  });
})();
